import React from "react";

import { LoadingIcon } from "@stormwater-software/lib-ui";
import { Modal } from "@stormwater-software/lib-ui";

export function MapLoadingSpinner() {
  return (
    <Modal show hideButtons isSmall disableClose>
      <div className="map-loader">
        <LoadingIcon />
        <p>Loading Map Editor...</p>
      </div>
    </Modal>
  );
}
